


































































import { Component, Prop, Vue } from 'vue-property-decorator';
import {
    AddressAttributeObject,
    AddressAttributeOption,
    QuoteAddress,
    SortedAddressAttributeObject,
} from '@/store/models';
import GmapAutocomplete from '@/components/Address/GmapAutocomplete.vue';
import { initState } from '@/store/stateinit';
import FormSelectField from '@/components/Address/FormSelectField.vue';
import FormInputField from '@/components/Address/FormInputField.vue';
import TelephonePrefixField from '@/components/Address/TelephonePrefixField.vue';
import store from '@/store';
import { placeFoundCallback } from '@/commons/gmap';

@Component({
    components: {
        GmapAutocomplete,
        FormSelectField,
        FormInputField,
        TelephonePrefixField,
    },
})
export default class AddressForm extends Vue {
    @Prop() public address!: QuoteAddress;
    @Prop() public isLoading!: boolean;
    public addressAttributes: AddressAttributeObject = initState('addressAttributes');
    public sortedAddressAttributes: SortedAddressAttributeObject = this.sortAddressAttributes;
    public showRegionInputField: boolean = !!this.getSelectOptions(
        'region_id',
        this.addressAttributes.region_id.options,
    ).length;

    get sortAddressAttributes() {
        return Object.entries(this.addressAttributes)
            .filter(([, attribute]) => attribute.code !== 'vat_id')
            .reduce<SortedAddressAttributeObject>((attributes, [, attribute]) => {
                attributes[attribute.group] = attributes[attribute.group] || [];
                attributes[attribute.group].push(attribute);
                return attributes;
            }, {});
    }

    public getFieldsetCode(code: string) {
        return code.replace(/\d+[_]/g, '');
    }

    public getFieldsetTitle(code: string) {
        const titles: any = {
            user: this.$t('Contact details').toString(),
            address: this.$t('Address details').toString(),
        };

        return titles[this.getFieldsetCode(code)];
    }

    public getSelectOptions(attribute: string, options: AddressAttributeOption[]) {
        switch (attribute) {
            case 'country_id':
                return options;

            case 'region_id':
                return this.getFilteredRegions(options);

            default:
                return [];
        }
    }

    public getFilteredRegions(regions: AddressAttributeOption[]) {
        return regions.filter((region: any) => region.country_id === this.address.country_id);
    }

    public setZipCodePortugal(countryId: string) {
        if (countryId === 'PT') {
            store.state.options.countrysettings.zipdigits = 8;
        } else {
            store.state.options.countrysettings.zipdigits = 5;
        }
    }

    public getModelValue(attributeCode: string) {
        switch (attributeCode) {
            case 'street':
                return this.address[attributeCode][0];

            case 'street_number':
                return this.address.street[1];

            case 'fiscaleitalia_fiscalcode':
                return this.address.extension_attributes[attributeCode];

            default:
                return this.address[attributeCode];
        }
    }

    public async updateModelValueHandler([value, attributeCode]: string[]) {
        switch (attributeCode) {
            case 'street':
                this.address.street[0] = value;
                break;

            case 'street_number':
                this.address.street[1] = value;
                break;

            case 'fiscaleitalia_fiscalcode':
                this.address.extension_attributes[attributeCode] = value;
                break;

            case 'country_id':
                this.address[attributeCode] = value;
                this.showRegionInputField = !!this.getSelectOptions(
                    'region_id',
                    this.addressAttributes.region_id.options,
                ).length;
                this.setZipCodePortugal(value);

                break;

            case 'telephone-prefix':
                this.address.telephone = value;
                break;

            default:
                this.address[attributeCode] = value;
                break;
        }
    }

    public async submitFormHandler() {
        const formFields = this.$refs.formField as FormInputField[] | FormSelectField[];
        const validatePromises: Array<Promise<boolean>> = [];

        formFields.forEach((field: any) => {
            validatePromises.push(field.$validator.validateAll());
        });

        const valid = Promise.all(validatePromises).then((values) => {
            return values.every((value) => value === true);
        });

        valid.then((value) => {
            if (value) {
                this.$emit('addressFormSubmitted', this.address);
            }
        });
    }

    public placeFoundHandler(place: google.maps.places.PlaceResult) {
        placeFoundCallback(place, this.address);
    }
}
